import React from "react";
import { TradeOrderInstructionContainer } from "../../../containers";

const TradeOrderInstruction = (props) => {
  return <TradeOrderInstructionContainer {...props} />;
};

export default TradeOrderInstruction;
